import React, { Component } from 'react';

export default class PrintableValueWithLabel extends Component<PrintableValueWithLabelProps> {
    static displayName = PrintableValueWithLabel.name;    
    
    render() {
        if (this.props.note) {
            return (
                <div className="printable-item" >
                    <span className="printable printable-label printable-note">
                        *{this.props.label}
                    </span>
                </div>
            );
        }
        else {
            return (
                <div className="printable-item" >
                    <span className="printable printable-label bold">
                        {`${this.props.label}:`}
                    </span>
                    <span className="dotted-fill"></span>
                    <span className="printable printable-value">
                        {this.props.value}
                    </span>
                </div>
            );
        }
    }
}